import { render, staticRenderFns } from "./AuthorizationDetails.vue?vue&type=template&id=1cc715de&scoped=true"
import script from "./AuthorizationDetails.vue?vue&type=script&lang=js"
export * from "./AuthorizationDetails.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationDetails.vue?vue&type=style&index=0&id=1cc715de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc715de",
  null
  
)

export default component.exports